import { axiosInstance } from '../../lib/helpers'

const BASE_PATH = '/auth'

export const adminEmailAndPasswordLoginApiMethod = (request: any) =>
  axiosInstance.post(`${BASE_PATH}/admin/login`, request)
